// Format is all uppercase with a space in the middle - A1A 1A1
//  This function assumes a valid postal code
export default function formatPostalCode(postalCode) {
    return postalCode.toUpperCase()
        .replace(/([A-Z]\d[A-Z])(\d[A-Z]\d)/, '$1 $2');
}
